module.exports = __webpack_public_path__ + "static/media/giraffe.be542405.png";